// File content comes from the customer's Drive: markdown for a Google Doc, plain
// text or CSV for everything else. Name and link are untrusted.

import { isString } from "../utils/schemaUtils";

export interface DriveFilePayload {
  type: "drive_file";
  id: string;
  name: string;
  mimeType: string;
  webViewLink: string;
  modifiedTime: string;
  content: string;
  // The content hit the export size cap, so the tail is missing.
  truncated?: boolean;
}

export const parseDriveFilePayload = (v: unknown): DriveFilePayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "drive_file") return null;
  if (!isString(r.id)) return null;
  if (!isString(r.name)) return null;
  if (!isString(r.mimeType)) return null;
  if (!isString(r.webViewLink)) return null;
  if (!isString(r.modifiedTime)) return null;
  if (!isString(r.content)) return null;
  return {
    type: "drive_file",
    id: r.id,
    name: r.name,
    mimeType: r.mimeType,
    webViewLink: r.webViewLink,
    modifiedTime: r.modifiedTime,
    content: r.content,
    truncated: r.truncated === true,
  };
};
